import { SlotLabel } from '@youshift/shared/types';
import { useTranslation } from 'react-i18next';

import { useChainContext } from '../../../../layouts/ChainLayout';

export type DefineCounterRuleDetailsProps = {
  selectedCounter: number | null;
  setSelectedCounter: (counter: number | null) => void;
};

export default function DefineCounterRuleDetails({
  selectedCounter,
  setSelectedCounter,
}: DefineCounterRuleDetailsProps) {
  const { t } = useTranslation();
  const { counters } = useChainContext();

  return (
    <div className="space-y-8 px-8">
      <div className="lg:flex lg:space-x-8">
        <div className="mt-4 lg:mt-0 lg:w-1/2">
          <label className="block text-sm font-medium text-gray-700">
            {t('manager.rulesConfig.selectCounter')}
          </label>
          <select
            value={selectedCounter || ''}
            onChange={e =>
              setSelectedCounter(e.target.value ? Number(e.target.value) : null)
            }
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
          >
            <option value="">
              {t('manager.rulesConfig.selectCounterPlaceholder')}
            </option>
            {Object.values(counters).map(counter => (
              <option
                key={counter.id_custom_counter}
                value={counter.id_custom_counter}
              >
                {counter.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
